import React, { useEffect, useRef, useState } from 'react';
import useCell from '../../SiteContext/useCell';
import { PageLoader as StyledPageLoader } from './styles';

const PageLoader = () => {
  const { loadingData } = useCell('main', true);
  const [loading, setLoading] = useState(loadingData);
  const timeout = useRef<NodeJS.Timeout>();

  useEffect(() => {
    if (!loading && loadingData) {
      timeout.current = setTimeout(() => setLoading(true), 500);
    } else if (!loadingData) {
      clearTimeout(timeout.current as NodeJS.Timeout);
      setLoading(false);
    }
  }, [loading, loadingData]);

  if (!loading) {
    return null;
  }

  return <StyledPageLoader />;
};

export default PageLoader;
